var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.toasts.length!==0)?_c('div',{staticClass:"toast-hub"},_vm._l((_vm.toasts),function(toast,index){return _c('div',{key:index,staticClass:"toast",attrs:{"data-success":"","data-type":toast.type.toLowerCase()}},[_vm._v("\n        "+_vm._s(toast.message)+"\n    ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }